export const releaseFlags = {
  portal_ssr: false,
  standalone_presentation_products_like_dislike: true,
};
